<template>
  <div class="contain">
    <div class="carousel-row">
      <div class="carousel-box">
        <div class="carousel-" id="carousel1">
          <el-carousel
            :autoplay="false"
            ref="carouselRef"
            height="100%"
            arrow="always"
            @change="changeCarousel"
            class="aspect-5/5 md:aspect-6/4"
          >
            <el-carousel-item
              :key="item"
              v-for="(item, i) in 7"
              :class="['carousel-item', `carousel-item${i}`]"
            >
              <img
                class="img aspect-5/5 md:aspect-6/4 object-cover"
                :src="`https://img.kamlung.net/kia/pv5/swiper2/${item}.jpg`"
              />
            </el-carousel-item>
          </el-carousel>
        </div>
        555555555
        <div class="scroll-r hidden-sm-and-down" id="scroll-r">
          <div
            class="img-box"
            @click="clickItem(item)"
            :id="`scroll-r_item${item}`"
            :key="item"
            v-for="(item, i) in 7"
            :class="{ 'img-box_shop': i === carouselIndex }"
          >
            <img
              class="img aspect-5/5 object-cover"
              :src="`https://img.kamlung.net/kia/pv5/swiper2/${item}.jpg?iopcmd=thumbnail&type=4&width=400&quality=60`"
            />
          </div>
        </div>

        <div class="scroll-b hidden-md-and-up" id="scroll-b">
          <div
            :key="item"
            class="img-box md:w-[150px] sm:w-[120px] w-[120px] md:h-[150px] sm:h-[120px] h-[120px]"
            @click="clickItem(item)"
            :id="`scroll-b_item${item}`"
            v-for="(item, i) in 7"
            :class="{ 'img-box_shop': i === carouselIndex }"
          >
            <img
              class="img aspect-5/5 object-cover"
              :src="`https://img.kamlung.net/kia/pv5/swiper2/${item}.jpg?iopcmd=thumbnail&type=4&width=400&quality=60`"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CarouselPage",

  data() {
    return {
      carouselIndex: 0,
      isDragging: false, // 是否正在拖拽
      startX: 0, // 鼠标按下时的X坐标
      startY: 0, // 鼠标按下时的Y坐标
      endX: 0, // 鼠标按下时的X坐标
    };
  },

  mounted() {
    setTimeout(() => {
      let carouselH = document.getElementById("carousel1").clientHeight;
      // console.log("carouselH :>> ", carouselH);
      document.getElementById("scroll-r").style.height = `${carouselH}px`;
    }, 300);

    // let carouselH = document.getElementById("carousel1").clientHeight;
    // console.log("carouselH :>> ", carouselH);
    // document.getElementById("scroll-r").style.height = `${carouselH}px`;
    this.slideBanner();
    this.slideBanner2();
    window.addEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      let carouselH = document.getElementById("carousel1").clientHeight;
      document.getElementById("scroll-r").style.height = `${carouselH}px`;
    },
    clickItem(e) {
      // this.initialIndex = e - 1;
      this.$refs.carouselRef.setActiveItem(e - 1);
    },
    changeCarousel(i) {
      this.carouselIndex = i;
      // let h_ = document.getElementById(`scroll-r_item${i + 1}`).offsetTop;
      // console.log("h_ :>> ", h_, i);
      document.getElementById("scroll-r").scrollTop = i * 200;

      // document.getElementById("scroll-r").scrollTop = h_ - 3000;
      // document.getElementById("scroll-r").scrollTop = h_ - 200;

      let l_ = document.getElementById(`scroll-b_item${i + 1}`).offsetLeft;
      // console.log("h_ :>> ", l_, i);
      document.getElementById("scroll-b").scrollLeft = l_ - 200;
      // var element = document.getElementById(`scroll-r_item${i + 1}`);
      // element.scrollIntoView({ behavior: "smooth" });
    },
    slideBanner2() {
      let box = document.querySelector(".el-carousel__container");
      let startPointX = 0;
      let stopPointX = 0;
      // let isDragging = false;
      box.addEventListener("mousedown", function (e) {
        // isDragging = true;
        // console.log("touchstart :>>开 ", e.clientX);
        startPointX = e.clientX;
      });
      // let chied = box.querySelector(`.carousel-item${this.carouselIndex}`);

      // box.addEventListener("mousemove", (e) => {
      //   if (isDragging) {
      //     let d_ = e.clientX - startPointX;
      //     // console.log("touchstart :>>移动", e.clientX);
      //     console.log("touchstart :>>移动", d_);
      //     chied.style.transform = `translateX(${d_}px)`;
      //     console.log("chied :>> ", chied);
      //     // element.style {
      //     // transform: translateX(-1000px)
      //     // }
      //   }
      //   // startPointX = e.clientX
      // });

      box.addEventListener("mouseup", (e) => {
        // isDragging = false;
        // console.log("touchend :>> 结", e.clientX);
        stopPointX = e.clientX;

        let d_ = startPointX - stopPointX;
        if (d_ > 5) {
          this.$refs.carouselRef.next();
          startPointX = 0;
          stopPointX = 0;
        }
        if (d_ < -5) {
          this.$refs.carouselRef.prev();
          startPointX = 0;
          stopPointX = 0;
        }
      });
    },
    slideBanner() {
      var box = document.querySelector(".el-carousel__container");
      var startPointX = 0;
      var stopPointX = 0;
      var resetPoint = function () {
        startPointX = 0;
        stopPointX = 0;
      };
      box.addEventListener("touchstart", function (e) {
        // console.log("touchstart :>> ");
        startPointX = e.changedTouches[0].pageX;
      });
      box.addEventListener("touchmove", function (e) {
        // console.log("touchmove :>> ");
        stopPointX = e.changedTouches[0].pageX;
      });
      let that = this;
      box.addEventListener("touchend", function () {
        // console.log("touchend :>> ");
        if (stopPointX == 0 || startPointX - stopPointX == 0) {
          resetPoint();
          return;
        }
        if (startPointX - stopPointX > 0) {
          resetPoint();
          that.$refs.carouselRef.next();
          return;
        }
        if (startPointX - stopPointX < 0) {
          resetPoint();
          that.$refs.carouselRef.prev();
          return;
        }
      });
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
@import "element-ui/lib/theme-chalk/display.css";
@media (min-width: 992px) {
  .carousel-box {
    display: flex;
    align-items: start;
  }
  .carousel- {
    flex: 1;
  }
}

.contain {
  white: 100%;
}
.carousel-row {
  white: 100%;
  // margin-top: 20px;
  // padding: 50px 0;
  background-color: #000;
  .carousel-box {
    margin: 0 auto;
    white: 100%;
    max-width: 1200px;
    // display: flex;
    // // justify-content: space-between;
    // align-items: start;
    .carousel- {
      // flex: 1;
    }
    .scroll-r {
      width: 200px;
      padding: 8px;
      overflow-y: auto;
      // display: none;
      .img-box:nth-child(n + 2) {
        padding-top: 8px;
      }
    }
    .scroll-r::-webkit-scrollbar {
      display: none;
    }

    .scroll-b {
      display: flex;
      justify-content: start;
      align-items: center;
      width: 100%;
      padding-top: 8px;
      // height: 200px;
      // padding: 8px;
      overflow-x: auto;
      // display: none;
      .img-box {
        // width: 200px;
        // height: 200px;
        flex-shrink: 0;
        padding-left: 8px;
      }

      .img-box:nth-child(n + 3) {
        padding-left: 8px;
      }
    }

    .scroll-b::-webkit-scrollbar {
      display: none;
    }
    .img-box {
      opacity: 0.4;
    }
    .img-box_shop {
      opacity: 1 !important;
    }
    .carousel-item {
      // height: 200px;
      .img {
        pointer-events: none;
      }
    }

    ::v-deep .el-carousel__button {
      width: 8px !important;
      height: 8px !important;
      border-radius: 50%;
    }
  }
}
</style>
